export default __webpack_public_path__ + "static/media/pdfImg.d73ff2b8.png";